import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <Page>
      <Shell>
        <BackLink to="/">Back to home</BackLink>
        <Card>
          <Eyebrow>Privacy Policy</Eyebrow>
          <Title>How Deliveries Tracker handles your information.</Title>
          <Updated>
            Last updated: <strong>October 21, 2021</strong>
          </Updated>

          <Section>
            <SectionTitle>1. Information We Collect</SectionTitle>
            <Paragraph>
              Deliveries Tracker is committed to protecting the privacy of its
              users. We do not collect personal data from users, and we do not
              track user data for resale or third-party sharing.
            </Paragraph>
            <Paragraph>
              We only store the information needed to provide the service, such
              as delivery details and tracking information. This information is
              kept secure and is only accessible by authorized personnel.
            </Paragraph>
          </Section>

          <Section>
            <SectionTitle>2. Changes to This Privacy Policy</SectionTitle>
            <Paragraph>
              This policy may be updated from time to time. Any changes take
              effect once the updated policy is posted on this page and, when
              applicable, communicated inside the app.
            </Paragraph>
          </Section>

          <Section>
            <SectionTitle>3. Contact</SectionTitle>
            <Paragraph>
              If you have questions or suggestions about this privacy policy,
              contact{" "}
              <ContactLink href="mailto:carlosmsilva83@gmail.com">
                carlosmsilva83@gmail.com
              </ContactLink>
              .
            </Paragraph>
          </Section>
        </Card>
      </Shell>
    </Page>
  );
}

const Page = styled.main`
  padding: 32px 20px 60px;
`;

const Shell = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const BackLink = styled(Link)`
  display: inline-flex;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.95rem;
`;

const Card = styled.article`
  padding: 32px;
  border-radius: 30px;
  background: ${({ theme }) => theme.colors.cardSurface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.colors.shadow};

  @media only screen and (max-width: ${({ theme }) => theme.mobileBreakpoint}) {
    padding: 24px;
  }
`;

const Eyebrow = styled.div`
  color: ${({ theme }) => theme.colors.accentDark};
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const Title = styled.h1`
  margin: 14px 0 10px;
  font-size: clamp(2.2rem, 5vw, 3.8rem);
  line-height: 1.02;
  letter-spacing: -0.05em;
`;

const Updated = styled.p`
  margin: 0 0 24px;
  color: ${({ theme }) => theme.colors.muted};
`;

const Section = styled.section`
  padding-top: 14px;
  border-top: 1px solid ${({ theme }) => theme.colors.border};

  & + & {
    margin-top: 18px;
  }
`;

const SectionTitle = styled.h2`
  margin: 0 0 10px;
  font-size: 1.3rem;
`;

const Paragraph = styled.p`
  margin: 0 0 14px;
  color: ${({ theme }) => theme.colors.ink};
  line-height: 1.75;
`;

const ContactLink = styled.a`
  color: ${({ theme }) => theme.colors.accentDark};
  font-weight: 700;
`;
